import {
  Box,
  CircularProgress,
  Grid,
  Typography,
  Paper,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { handleAxiosError } from "../../config/action-config";
import {
  ContentCopyRounded,
  InfoOutlined,
  PersonPinCircleOutlined,
} from "@mui/icons-material";
import TimelineIcon from "@mui/icons-material/Timeline";
import {
  getDashboardCaseType,
  getDashboardCasesStatus,
  getDashboardDueDate,
} from "../../api/dashboard";
import DashboardCard from "../../components/dashboardCard";
import DeadlineWidget from "../../components/DeadlineWidget";
import AwaitingWidget from "../../components/AwaitingWidget";
import { useNavigate } from "react-router-dom";
import useErrorHandler from "../../hooks/useErrorHandler";

const emptyData = {
  INITIAL: "0",
  OPEN: "0",
  CLOSED: "0",
};
export default function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const errorHandler = useErrorHandler();
  const { data: user } = useSelector((state) => state.user);
  const [statusdata, setStatusData] = useState(emptyData);
  const [allData, setAllData] = useState([]);
  const [typedata, settypeData] = useState({
    options: {},
    series: [],
  });
  const [dueCasesData, setDueCasesData] = useState({
    options: {},
    series: [],
  });
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    if (user.token) {
      getDashboardStatusGraph();
      getDashboardTypeGraph();
      getDashboardDueDateGraph();
    }
    return;
  }, []);
  const getDashboardStatusGraph = () => {
    setLoader(true);
    getDashboardCasesStatus(user.token)
      .then((response) => {
        if (response.data.data.length) {
          const data = response.data.data.reduce((acc, curr) => {
            acc[curr.status] = curr.count;
            return acc;
          }, {});

          const combinedData = {
            INITIAL: data.INITIAL || "0",
            OPEN: data.OPEN || "0",
            CLOSED: data.CLOSED || "0",
          };

          setStatusData(combinedData);
        }
        setLoader(false);
      })
      .catch((err) => {
        errorHandler(err);
      });
  };
  const getDashboardTypeGraph = () => {
    setLoader(true);
    getDashboardCaseType(user.token)
      .then((response) => {
        if (response.data.data.length) {
          const newData = response.data.data;
          const labels = newData.map((item) => item.type);
          const values = newData.map((item) => item.count);
          settypeData({
            options: {
              chart: {
                id: "mychart",
                //height: '400px'
                //---Sneha Add---//
                stacked: true,
                toolbar: {
                  show: true,
                },
                zoom: {
                  enabled: true,
                },
                animations: {
                  enabled: true,
                  easing: "easeinout",
                  speed: 800,
                  animateGradually: {
                    enabled: true,
                    delay: 150,
                  },
                  dynamicAnimation: {
                    enabled: true,
                    speed: 350,
                  },
                },
                //---End Sneha Add---//
              },
              //---Sneha Add---//
              responsive: [
                {
                  breakpoint: 480,
                  options: {
                    legend: {
                      position: "bottom",
                      offsetX: -10,
                      offsetY: 0,
                    },
                  },
                },
              ],
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: "50%",
                },
              },
              //---End Sneha Add---//
              colors: ["#4a82a7"],
              // colors: ["#32d074"],
              dataLabels: {
                // enabled: true,
                enabled: false,
                offsetX: -6,

                style: {
                  fontSize: "10px",
                  colors: ["black"],
                },
              },

              xaxis: {
                categories: labels,
                title: {
                  text: "Case Types",
                  style: {
                    fontWeight: "500",
                    fontSize: "12px",
                  },
                },
                labels: {
                  rotate: -90,
                  minHeight: 150,
                },
              },
              yaxis: {
                title: {
                  text: "Cases",
                  style: {
                    fontWeight: "500",
                    fontSize: "12px",
                  },
                },
                labels: {
                  formatter: function (value) {
                    return parseInt(value); // convert the value to an integer
                  },
                },
              },
              //---Sneha Add---//

              legend: {
                show: true,
                fontSize: "14px",
                position: "bottom",
                offsetX: 20,
                labels: {
                  useSeriesColors: false,
                },
                markers: {
                  width: 16,
                  height: 16,
                  radius: 5,
                },
                itemMargin: {
                  horizontal: 15,
                  vertical: 8,
                },
              },
              fill: {
                type: "solid",
              },
              dataLabels: {
                enabled: false,
              },
              grid: {
                show: true,
              },
              //---End Sneha Add---//
            },
            series: [
              {
                name: "Values",
                data: values,
              },
            ],
          });
        }
        setLoader(false);
      })
      .catch((err) => {
        errorHandler(err);
      });
  };
  const getDashboardDueDateGraph = () => {
    setLoader(true);
    getDashboardDueDate(user.token)
      .then((response) => {
        if (response.data.data.length) {
          const newData = response.data.data;
          setAllData(newData);
          const labels = newData.map((item) => item.title);
          const values = newData.map((item) => item.due_days.days + 1);
          setDueCasesData({
            options: {
              chart: {
                id: "mychart",
                //height: '400px'
                stacked: true,
                toolbar: {
                  show: true,
                },
                zoom: {
                  enabled: true,
                },
                animations: {
                  enabled: true,
                  easing: "easeinout",
                  speed: 800,
                  animateGradually: {
                    enabled: true,
                    delay: 150,
                  },
                  dynamicAnimation: {
                    enabled: true,
                    speed: 350,
                  },
                },
              },
              //---Sneha Add---//
              responsive: [
                {
                  breakpoint: 480,
                  options: {
                    legend: {
                      position: "bottom",
                      offsetX: -10,
                      offsetY: 0,
                    },
                  },
                },
              ],
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: "50%",
                },
              },
              //---End Sneha Add---//
              colors: ["#26619c"],
              dataLabels: {
                // enabled: true,
                enabled: false,
                offsetX: -6,

                style: {
                  fontSize: "10px",
                  colors: ["black"],
                },
              },

              xaxis: {
                categories: labels,
                title: {
                  text: "Case Title",
                  style: {
                    fontWeight: "500",
                    fontSize: "12px",
                  },
                },
                labels: {
                  rotate: -90,
                  minHeight: 150,
                },
              },
              //---Sneha Add---//

              legend: {
                show: true,
                fontSize: "14px",
                fontFamily: `'Roboto', sans-serif`,
                position: "bottom",
                offsetX: 20,
                labels: {
                  useSeriesColors: false,
                },
                markers: {
                  width: 16,
                  height: 16,
                  radius: 5,
                },
                itemMargin: {
                  horizontal: 15,
                  vertical: 8,
                },
              },
              fill: {
                type: "solid",
              },
              dataLabels: {
                enabled: false,
              },
              grid: {
                show: true,
              },
              //---End Sneha Add---//
              yaxis: {
                title: {
                  text: "Due Days",
                  style: {
                    fontWeight: "500",
                    fontSize: "12px",
                  },
                },
              },
            },
            series: [
              {
                name: "Values",
                data: values,
              },
            ],
          });
        }
        setLoader(false);
      })
      .catch((err) => {
        errorHandler(err);
      });
  };

  const handleClick = (event) => {
    const pathElement = document.getElementById(
      event.target.getAttribute("id")
    );
    const selectedIndex = pathElement.getAttribute("j");
    const filterObject = allData[selectedIndex];
    const id = filterObject.id;
    navigate(`/cases/${id}`);
  };
  return (
    <div className="container-dash">
      {loader === false ? (
        /*<Box component="main" sx={{ flexGrow: 1, p: 3, ml: 9 }}>*/
        <Box component="main">
          <Grid container spacing={1}>
            <Grid item xs={12} sm={4} md={4} lg={4} className="card1-bkg">
              <DashboardCard
                total={statusdata.INITIAL}
                tittle={"Initial Cases"}
              >
                <ContentCopyRounded
                  className="mui-icon iconfirst !text-[40px] !text-white"
                />
              </DashboardCard>
              {/* <AppCustomerCard /> */}
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={4} className="card2-bkg">
              <DashboardCard total={statusdata.OPEN} tittle={"Open Cases"}>
                <InfoOutlined
                  className="mui-icon iconsecond !text-[40px] !text-white"
                />
              </DashboardCard>
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={4} className="card3-bkg">
              <DashboardCard total={statusdata.CLOSED} tittle={"Closed Cases"}>
                <TimelineIcon
                  className="mui-icon iconthird !text-[40px] !text-white"
                />
              </DashboardCard>
            </Grid>
          </Grid>

          <DeadlineWidget />
          <AwaitingWidget />

          <Grid container rowSpacing={2} columnSpacing={2} mt={2}>
            <Grid item xs={12} sm={6} md={6}>
              <Paper className="odr-card">
                {/* <Box
                  display="flex"
                  justifyContent="space-between"
                  className="odr-card-header"
                >
                  <Typography className="heading-title">Due Cases</Typography>
                </Box> */}
                <Box>
                  <Chart
                    options={dueCasesData.options}
                    series={dueCasesData.series}
                    type="bar"
                    height="390"
                    className="quote-line-chart"
                    onClick={handleClick}
                  />
                </Box>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <Paper className="odr-card">
                {/* <Box
                  display="flex"
                  justifyContent="space-between"
                  className="odr-card-header"
                >
                  <Typography className="heading-title">Case Types</Typography>
                </Box> */}
                {/* <Box sx={{ mt: 2, mb: 2 }}>
                  <Typography>Case Types</Typography>
                </Box> */}
                <Box>
                  <Chart
                    options={typedata.options}
                    series={typedata.series}
                    type="bar"
                    height="390"
                    className="quote-line-chart"
                  />
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <div className="w-full h-[500px] flex justify-center items-center">
          <CircularProgress></CircularProgress>
        </div>
      )}
    </div>
  );
}

//   let arr = [...response.data.data];
//   let initial = arr.find((o) => o.status === "INITIAL");
//   let open = arr.find((o) => o.status === "OPEN");
//   let closed = arr.find((o) => o.status === "CLOSED");
//   console.log("closed", closed);
//   const combinedData = {
//     INITIAL: initial ? initial.count : "0",
//     OPEN: open ? open.count : "0",
//     CLOSED: closed === undefined ? "0" : closed.count,
//   };
//   setStatusData(combinedData);
